// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 优惠券 添加
 * @param pram
 */
export function platformCouponAddApi(data) {
  return request({
    url: '/admin/platform/coupon/add',
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 列表
 * @param pram
 */
export function platformCouponListApi(params) {
  return request({
    url: '/admin/platform/coupon/list',
    method: 'get',
    params: params
  });
}

/**
 * 用户管理 发送优惠券
 * @param pram
 */
export function couponSendApi(data) {
  return request({
    url: '/admin/platform/coupon/batch/send',
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 可发送优惠券列表
 * @param pram
 */
export function canSendListApi(params) {
  return request({
    url: '/admin/platform/coupon/can/send/list',
    method: 'get',
    params: params
  });
}

/**
 * 优惠券 详情
 * @param pram
 */
export function couponInfoApi(id) {
  return request({
    url: "/admin/platform/coupon/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 优惠券 修改状态
 * @param pram
 */
export function couponStatusApi(id) {
  return request({
    url: "/admin/platform/coupon/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 优惠券 删除
 * @param pram
 */
export function couponDeleteApi(data) {
  return request({
    url: '/admin/platform/coupon/delete',
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 优惠券记录列表
 * @param pram
 */
export function couponUserListApi(params) {
  return request({
    url: '/admin/platform/coupon/user/list',
    method: 'get',
    params: params
  });
}

/**
 * 优惠券 编辑
 * @param pram
 */
export function platformCouponEditApi(data) {
  return request({
    url: '/admin/platform/coupon/update',
    method: 'post',
    data: data
  });
}

/**
 * 新人礼 获取
 * @param pram
 */
export function newPeoplePresentConfigApi() {
  return request({
    url: '/admin/platform/marketing/activity/new/people/present/config',
    method: 'get'
  });
}

/**
 * 生日礼 获取
 * @param pram
 */
export function birthdayPresentConfigApi() {
  return request({
    url: '/admin/platform/marketing/activity/birthday/present/config',
    method: 'get'
  });
}

/**
 * 新人礼 编辑
 * @param pram
 */
export function newPeoplePresentEditApi(data) {
  return request({
    url: '/admin/platform/marketing/activity/new/people/present/edit',
    method: 'post',
    data: data
  });
}

/**
 * 生日礼 编辑
 * @param pram
 */
export function birthdayPresentEditApi(data) {
  return request({
    url: '/admin/platform/marketing/activity/birthday/present/edit',
    method: 'post',
    data: data
  });
}

/**
 * 积分日志 列表
 * @param pram
 */
export function integralListApi(params, data) {
  return request({
    url: '/admin/platform/integral/list',
    method: 'get',
    params: params,
    data: data
  });
}

/**
 * 签到 基础签到配置
 */
export function signBaseConfigApi(data) {
  return request({
    url: "/admin/platform/sign/edit/base/config",
    method: 'post',
    data: data
  });
}

/**
 * 签到 新增连续签到配置
 */
export function signAddConfigApi(data) {
  return request({
    url: "/admin/platform/sign/add/config",
    method: 'post',
    data: data
  });
}

/**
 * 签到 编辑连续签到配置
 */
export function signeEditConfigApi(data) {
  return request({
    url: "/admin/platform/sign/edit/award/config",
    method: 'post',
    data: data
  });
}

/**
 * 签到 删除连续签到配置
 */
export function signeDelConfigApi(id) {
  return request({
    url: "/admin/platform/sign/delete/config/".concat(id),
    method: 'post'
  });
}

/**
 * 签到 获取签到配置
 */
export function signeGetConfigApi() {
  return request({
    url: "/admin/platform/sign/get/config",
    method: 'get'
  });
}

/**
 * 签到 用户签到记录分页列表
 */
export function signeRecordListApi() {
  return request({
    url: "/admin/platform/sign/user/record/list",
    method: 'get'
  });
}

/**
 * 秒杀 秒杀时段列表
 */
export function seckillIntervalListApi(params) {
  return request({
    url: "/admin/platform/seckill/time/interval/list",
    method: 'get',
    params: params
  });
}

/**
 * 秒杀 新增秒杀时段
 */
export function seckillIntervalAddApi(data) {
  return request({
    url: "/admin/platform/seckill/time/interval/add",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 编辑秒杀时段
 */
export function seckillIntervalUpdateApi(data) {
  return request({
    url: "/admin/platform/seckill/time/interval/update",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 删除秒杀时段
 */
export function seckillIntervalDeleteApi(id) {
  return request({
    url: "admin/platform/seckill/time/interval/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 秒杀时段开关
 */
export function seckillIntervalSwitcheApi(id) {
  return request({
    url: "admin/platform/seckill/time/interval/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 新增秒杀活动
 */
export function seckillActivityAddApi(data) {
  return request({
    url: "/admin/platform/seckill/activity/add",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 秒杀活动详情
 */
export function seckillActivityDetailApi(id) {
  return request({
    url: "/admin/platform/seckill/activity/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 秒杀 秒杀活动分页列表
 */
export function seckillActivityListApi(params) {
  return request({
    url: "/admin/platform/seckill/activity/page",
    method: 'get',
    params: params
  });
}

/**
 * 秒杀 删除秒杀活动
 */
export function seckillAtivityDelApi(id) {
  return request({
    url: "/admin/platform/seckill/activity/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 编辑秒杀活动
 */
export function seckillAtivityUpdateApi(data) {
  return request({
    url: "/admin/platform/seckill/activity/update",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 秒杀活动开关
 */
export function seckillAtivitySwitchApi(id) {
  return request({
    url: "/admin/platform/seckill/activity/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 秒杀商品列表
 */
export function seckillProListApi(params) {
  return request({
    url: "/admin/platform/seckill/product/page",
    method: 'get',
    params: params
  });
}

/**
 * 秒杀 秒杀商品删除
 */
export function seckillProDelApi(data) {
  return request({
    url: "/admin/platform/seckill/product/delete",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 秒杀商品设置活动价
 */
export function seckillProSetPriceApi(data) {
  return request({
    url: "/admin/platform/seckill/product/set/price",
    method: 'post',
    data: data
  });
}

/**
 * 秒杀 秒杀商品下架
 */
export function seckillProDownApi(data) {
  return request({
    url: "/admin/platform/seckill/product/down",
    method: 'post',
    data: data
  });
}

/**
 * 秒杀 秒杀商品审核
 */
export function seckillProAuditApi(data) {
  return request({
    url: "/admin/platform/seckill/product/audit",
    method: 'post',
    data: data
  });
}

/**
 * 投票活动 活动分页列表
 */
export function voteActivityPageApi(params) {
  return request({
    url: "/admin/platform/vote/activity/page",
    method: 'get',
    params: params
  });
}

/**
 * 投票活动 活动详情
 */
export function voteActivityDetailApi(id) {
  return request({
    url: "/admin/platform/vote/activity/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 投票活动 创建活动
 */
export function voteActivityAddApi(data) {
  return request({
    url: "/admin/platform/vote/activity/add",
    method: 'post',
    data: data
  });
}

/**
 * 投票活动 编辑活动
 */
export function voteActivityUpdateApi(data) {
  return request({
    url: "/admin/platform/vote/activity/update",
    method: 'post',
    data: data
  });
}

/**
 * 投票活动 活动上下线切换
 */
export function voteActivitySwitchApi(id) {
  return request({
    url: "/admin/platform/vote/activity/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 投票活动 作品分页列表
 */
export function voteWorkPageApi(params) {
  return request({
    url: "/admin/platform/vote/work/page",
    method: 'get',
    params: params
  });
}

/**
 * 投票活动 作品上架下架
 */
export function voteWorkSwitchApi(id) {
  return request({
    url: "/admin/platform/vote/work/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 投票活动 票数修正
 */
export function voteWorkTicketAdjustApi(data) {
  return request({
    url: "/admin/platform/vote/work/ticket/adjust",
    method: 'post',
    data: data
  });
}
/**
 * @description 氛围图 -- 选择商品列表 氛围图、活动边框公用同一接口，type传值判断
 */
export function selectProductList(data) {
  return request.get("marketing/spu/lst", data);
}
/**
 * @description 氛围图 -- 创建氛围图
 */
export function createAtuosphere(data) {
  return request.post("admin/platform/activitystyle/save", data);
}
/**
 * @description 氛围图 -- 编辑氛围图
 */
export function atuosphereUpdateApi(data) {
  return request.post("admin/platform/activitystyle/update", data);
}
/**
 * @description 活动样式
 */
export function atuosphereList(params) {
  return request({
    url: "/admin/platform/activitystyle/list",
    method: 'get',
    params: params
  });
}
/**
 * @description 活动样式
 */
export function atmosphereStatusApi(data) {
  return request({
    url: "/admin/platform/activitystyle/status",
    method: 'post',
    data: data
  });
}
/**
 * @description 活动样式
 */
export function atmosphereDelete(params) {
  return request({
    url: "/admin/platform/activitystyle/delete",
    method: 'get',
    params: params
  });
}
/**
 * @description 秒杀商品添加
 */
export function seckillProAdd(data) {
  return request({
    url: "/admin/platform/seckill/product/add",
    method: 'POST',
    data: data
  });
}

/**
 * @description 直播-商品-删除
 */
export function liveGoodsDelApi(id) {
  return request({
    url: "/admin/platform/mp/live/goods/delete/".concat(id),
    method: 'get'
  });
}

/**
 * @description 直播-商品-详情
 */
export function liveGoodsInfoApi(id) {
  return request({
    url: "/admin/platform/mp/live/goods/info/".concat(id),
    method: 'get'
  });
}

/**
 * @description 直播-商品-分页列表
 */
export function liveGoodsListApi(params) {
  return request({
    url: "/admin/platform/mp/live/goods/list",
    method: 'get',
    params: params
  });
}

/**
 * @description 直播-商品-平台审核
 */
export function liveGoodsReviewApi(data) {
  return request({
    url: "/admin/platform/mp/live/goods/review",
    method: 'POST',
    data: data
  });
}

/**
 * @description 直播-商品-修改排序
 */
export function liveGoodsSortApi(id, sort) {
  return request({
    url: "/admin/platform/mp/live/goods/sort/".concat(id, "/").concat(sort),
    method: 'GET'
  });
}

/**
 * @description 直播-直播间 列表
 */
export function liveRoomListApi(data) {
  return request({
    url: "/admin/platform/mp/live/room/list",
    method: 'post',
    data: {
      pageParamRequest: {
        limit: data.limit,
        page: data.page
      },
      searchRequest: {
        reviewStatus: data.reviewStatus,
        liveStatus: data.liveStatus,
        keywords: data.keywords,
        storeShow: data.storeShow,
        merType: data.merType,
        star: data.star
      }
    }
  });
}

/**
 * 直播 直播间 删除直播室
 */
export function liveRoomDeleteApi(roomId) {
  return request({
    url: "/admin/platform/mp/live/room/delete/".concat(roomId),
    method: 'GET'
  });
}

/**
 * 直播 直播间 商品排序
 */
export function liveRoomGoodsortApi(data) {
  return request({
    url: "/admin/platform/mp/live/room/goodsort",
    method: 'post',
    data: data
  });
}

/**
 * 直播 直播间 关闭评论
 */
export function liveRoomUpdatecommentApi(id, banComment) {
  return request({
    url: "/admin/platform/mp/live/room/updatecomment/".concat(id, "/").concat(banComment),
    method: 'get'
  });
}

/**
 * 直播 直播间 客服管理
 */
export function liveRoomUpdatefeedpublicApi(id, closeKf) {
  return request({
    url: "/admin/platform/mp/live/room/updatefeedpublic/".concat(id, "/").concat(closeKf),
    method: 'get'
  });
}

/**
 * 直播 直播间 官方收录管理
 */
export function liveRoomIsFeedsPublicApi(id, isFeedsPublic) {
  return request({
    url: "/admin/platform/mp/live/room/updatefeedpublic/".concat(id, "/").concat(isFeedsPublic),
    method: 'get'
  });
}

/**
 * 直播 直播间 开启回放
 */
export function liveRoomUpdatereplayApi(id, closeReplay) {
  return request({
    url: "/admin/platform/mp/live/room/updatereplay/".concat(id, "/").concat(closeReplay),
    method: 'get'
  });
}

/**
 * 直播 直播间 直播间商品列表
 */
export function liveRoomGoodsListApi(id) {
  return request({
    url: "/admin/platform/mp/live/room/goodslist/".concat(id),
    method: 'get'
  });
}

/**
 * 直播 直播间 直播室审核
 */
export function liveRoomReviewApi(data) {
  return request({
    url: "/admin/platform/mp/live/room/review",
    method: 'post',
    data: data
  });
}

/**
 * 直播 直播间 显示在商城
 */
export function liveRoomShowApi(id, show) {
  return request({
    url: "/admin/platform/mp/live/room/showstore/".concat(id, "/").concat(show),
    method: 'get'
  });
}

/**
 * 礼物
 */

/**
 * 礼物列表
 * @param pram
 */
export function giftListApi(params) {
  return request({
    url: "/admin/platform/gift/list",
    method: 'get',
    params: params
  });
}

/**
 * 礼物赠送记录
 * @param pram
 */
export function giftGiveRecordListApi(params) {
  return request({
    url: "/admin/platform/gift/give/record/list",
    method: 'get',
    params: params
  });
}

/**
 * 礼物新增
 * @param pram
 */
export function giftAddApi(data) {
  return request({
    url: "/admin/platform/gift/add",
    method: 'post',
    data: data
  });
}

/**
 * 礼物删除
 * @param pram
 */
export function giftDeleteApi(params) {
  return request({
    url: "/admin/platform/gift/delete",
    method: 'post',
    params: params
  });
}

/**
 * 礼物修改
 * @param pram
 */
export function giftUpdateApi(data) {
  return request({
    url: "/admin/platform/gift/update",
    method: 'post',
    data: data
  });
}

/**
 * 礼物状态更新
 * @param pram
 */
export function giftUpdateStatusApi(data) {
  return request({
    url: "/admin/platform/gift/updateStatus",
    method: 'post',
    data: data
  });
}

/**
 * 企业-投票活动 专家白名单-删除
 * @param {number} id - 白名单ID
 * @returns {Promise} 返回删除结果
 * @description 删除投票活动的专家白名单
 */
export function companyVoteExpertWhitelistDeleteApi(id) {
  return request({
    url: "/admin/company/vote/activity/expert/whitelist/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 企业-投票活动 专家白名单-新增
 * @param {Object} data - 请求参数
 * @param {number} data.activityId - 活动ID
 * @param {string} data.phoneStr - 手机号字符串，多个手机号用英文逗号分隔
 * @returns {Promise} 返回新增结果
 * @description 添加投票活动的专家白名单
 */
export function companyVoteExpertWhitelistInsertApi(data) {
  return request({
    url: "/admin/company/vote/activity/expert/whitelist/insert",
    method: 'POST',
    data: data
  });
}

/**
 * 企业-投票活动 专家白名单-列表查询
 * @param {Object} params - 查询参数
 * @param {number} params.activityId - 活动ID（可选）
 * @param {number} params.id - ID（可选）
 * @param {string} params.phone - 手机号（可选）
 * @param {number} params.userUid - 用户ID（可选）
 * @returns {Promise} 返回专家白名单列表
 * @description 查询投票活动专家白名单
 */
export function companyVoteExpertWhitelistQueryApi(params) {
  return request({
    url: "/admin/company/vote/activity/expert/whitelist/query",
    method: 'GET',
    params: params
  });
}

/**
 * 企业-投票活动 创建活动
 * @param {Object} data - 请求参数
 * @param {number} data.dailyVoteLimitPerUser - 每个用户每天可投几票
 * @param {number} data.dailyVoteLimitPerWork - 每个作品每天最多被投几次
 * @param {string} data.description - 活动描述
 * @param {number} data.expertReviewVotes - 专家点评附带投票数量
 * @param {string} data.image - 活动封面图
 * @param {string} data.name - 活动标题
 * @param {number} data.publishStatus - 发布状态：0-未上线，1-已上线
 * @param {string} data.registerEndTime - 报名结束时间
 * @param {string} data.registerStartTime - 报名开始时间
 * @param {string} data.remark - 备注
 * @param {string} data.rule - 活动规则
 * @param {number} data.sort - 排序
 * @param {number} data.stageStatus - 活动状态：0-报名中，1-投票中，2-已结束
 * @param {string} data.voteEndTime - 投票结束时间
 * @param {string} data.voteStartTime - 投票开始时间
 * @returns {Promise} 返回创建结果
 * @description 创建投票活动
 */
export function companyVoteActivityInsertApi(data) {
  return request({
    url: "/admin/company/vote/activity/insert",
    method: 'POST',
    data: data
  });
}

/**
 * 企业-投票活动 列表查询
 * @param {Object} params - 查询参数
 * @param {number} params.id - ID（可选）
 * @param {string} params.name - 活动标题（可选）
 * @param {number} params.publishStatus - 发布状态：0-未上线，1-已上线（可选）
 * @param {number} params.stageStatus - 活动状态：0-报名中，1-投票中，2-已结束（可选）
 * @returns {Promise} 返回活动列表
 * @description 查询投票活动列表
 */
export function companyVoteActivityQueryApi(params) {
  return request({
    url: "/admin/company/vote/activity/query",
    method: 'GET',
    params: params
  });
}

/**
 * 企业-投票活动 编辑活动
 * @param {Object} data - 请求参数
 * @param {number} data.id - 活动ID（必填）
 * @param {number} data.dailyVoteLimitPerUser - 每个用户每天可投几票
 * @param {number} data.dailyVoteLimitPerWork - 每个作品每天最多被投几次
 * @param {string} data.description - 活动描述
 * @param {number} data.expertReviewVotes - 专家点评附带投票数量
 * @param {string} data.image - 活动封面图
 * @param {string} data.name - 活动标题
 * @param {number} data.publishStatus - 发布状态：0-未上线，1-已上线
 * @param {string} data.registerEndTime - 报名结束时间
 * @param {string} data.registerStartTime - 报名开始时间
 * @param {string} data.remark - 备注
 * @param {string} data.rule - 活动规则
 * @param {number} data.sort - 排序
 * @param {number} data.stageStatus - 活动状态：0-报名中，1-投票中，2-已结束
 * @param {string} data.voteEndTime - 投票结束时间
 * @param {string} data.voteStartTime - 投票开始时间
 * @returns {Promise} 返回编辑结果
 * @description 编辑投票活动
 */
export function companyVoteActivityUpdateApi(data) {
  return request({
    url: "/admin/company/vote/activity/update",
    method: 'PUT',
    data: data
  });
}

/**
 * 企业-投票活动 参赛人员-查询
 * @param {Object} params - 查询参数
 * @param {number} params.activityId - 活动ID（可选）
 * @param {number} params.page - 页码（可选）
 * @param {number} params.limit - 每页条数（可选）
 * @param {number} params.id - ID（可选）
 * @param {string} params.orderByStr - 排序规则：1-按票数从高到低、2-按票数从低到高、3-按报名时间从早到晚、4-按报名时间从晚到早（可选）
 * @param {number} params.ranking - 参赛作品排名（可选）
 * @param {number} params.status - 参赛作品状态：0-下架，1-上架（可选）
 * @param {number} params.userUid - 参赛人员ID（可选）
 * @param {number} params.workId - 参赛作品ID（可选）
 * @returns {Promise<{
 *   list:Array<{
 *     activityId:number,
 *     auditStatus:number,
 *     createTime:string,
 *     description:string,
 *     id:number,
 *     ranking:number,
 *     remark:string,
 *     status:number,
 *     userUid:number,
 *     vote:number,
 *     workId:number,
 *     workUrl:string
 *   }>,
 *   page:number,
 *   limit:number,
 *   total:number
 * }>} 返回参赛人员列表
 * @description 查询投票活动参赛人员列表
 */
export function companyVoteActivityUserQueryApi(params) {
  return request({
    url: "/admin/company/vote/activity/user/query",
    method: 'GET',
    params: params
  });
}

/**
 * 企业-投票活动 参赛人员-修改
 * @param {Object} data - 请求参数
 * @param {number} data.id - ID（必填）
 * @param {number} data.activityId - 活动ID（可选）
 * @param {number} data.auditStatus - 作品审核状态：1-待审核，2-通过，3-未通过（可选）
 * @param {string} data.description - 参赛人员描述（可选）
 * @param {number} data.ranking - 参赛作品排名（可选）
 * @param {string} data.remark - 备注（可选）
 * @param {number} data.status - 参赛作品状态：0-下架，1-上架（可选）
 * @param {number} data.userUid - 参赛人员ID（可选）
 * @param {number} data.vote - 参赛作品获得票数（可选）
 * @param {number} data.workId - 参赛作品ID（可选）
 * @param {string} data.workUrl - 作品地址（可选）
 * @returns {Promise} 返回修改结果
 * @description 修改投票活动参赛人员信息
 */
export function companyVoteActivityUserUpdateApi(data) {
  return request({
    url: "/admin/company/vote/activity/user/update",
    method: 'PUT',
    data: data
  });
}